import React from "react";
import { Link } from "react-router-dom";
import Flex from "../../Misc/Flex";
import ProductRackCell from "./ProductRackCell";
export default function ProductBrief(props) {
  return (
    <div
      className={`text-dark-50 small ${
        props.row ? "row" : "d-flex align-items-center justify-content-start"
      }`}
    >
      <div className={`${props.row ? "col-3" : "mr-2"}`}>
        {props.storageLink && (
          <Link to={`/product/${props.storage}`}>{props.storagename}</Link>
        )}
        {!props.storageLink && <>{props.storagename}</>}
      </div>
      <div className={`${props.row ? "col-3" : "mr-2"}`}>
        <ProductRackCell {...props} />
      </div>
      <div className={`${props.row ? "col-3" : "mr-2"}`}>
        {props.balance} {props.measurename}
      </div>
      <div className={`${props.row ? "col-3" : "mr-2"}`}>
        <Flex between>
          <div>
            {props.price} {props.currencyname}
          </div>
          {props.suffix}
        </Flex>
      </div>
    </div>
  );
}
